import React from "react"
import styles from "./styles.scss"
import SideNav from "components/SideNav"
import { getCounties, selectCountiesAsArray } from "data/counties"
import { getAd, selectAd, updateAd } from "data/ads"
import { connect } from "react-redux"
import AdForm from "components/AdForm"
import AdminHeader from "pages/Admin/components/AdminHeader"

class AdEdit extends React.Component {
  constructor(props) {
    super(props)
    const {
      match: {
        params: { id },
      },
    } = props
    id && props.getAd(id)
    props.getCounties()
  }
  handleSubmit = values => {
    const adCounties = values.adCounties.map(county => ({
      countyId: county.value,
    }))

    const ad = {
      title: values.adTitle,
      body: values.adBody,
      adUrl: values.adUrl,
      isActive: values.adIsActive,
      adCounties,
    }
    this.props.updateAd(this.props.match.params.id, ad)
  }
  getInitialValues = () => {
    const { ad } = this.props

    return {
      adTitle: ad.title,
      adBody: ad.body,
      adUrl: ad.adUrl,
      imgurl: ad.imgurl,
      adIsActive: ad.isActive,
      adCounties: ad.adCounties.map(adCounty => ({
        value: adCounty.county.id,
        label: adCounty.county.name,
      })),
    }
  }
  render() {
    const { ad, counties } = this.props
    return (
      <div className={styles.container}>
        <div className={styles.mainContent}>
          <AdminHeader/>

          <div className={styles.adformWrapper}>
            <SideNav type="ads" />
            {ad && (
              <div className={styles.adForm}>
                <h4>Redigera en annons: {ad.title}</h4>
                <AdForm
                  ad={ad}
                  counties={counties}
                  onSubmit={this.handleSubmit}
                  submitText="Spara"
                  initialValues={this.getInitialValues()}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => ({
  ad: selectAd(state, ownProps),
  counties: selectCountiesAsArray(state, ownProps),
})

export default connect(
  mapStateToProps,
  {
    getAd,
    getCounties,
    updateAd,
  }
)(AdEdit)



// WEBPACK FOOTER //
// src/pages/Admin/Ads/AdEdit/index.jsx